/**
 * Created by wangshhj on 2018/1/10.
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import OriginSelect from 'bee-select';
import { Select as OriginSelect } from "@tinper/next-ui";
import { hasValue, hasBackSpaceClear } from './util';
import { isIE, getSysFieldid, keyboard, getSafeRandom, getGlobalStorage, isBooleanType, microAppUtil } from '@platform/api';

//require('bee-select/build/Select.css');
require('./index.less');

const Option = OriginSelect.Option;
const OptGroup = OriginSelect.OptGroup;

const { isKeyboard, isArrowKeyDown, isEnterKeyDown, KeyCode, isComboKeyboard } = keyboard;
class Select extends Component {
    constructor(props) {
        super(props);
        let defaultOpen = this.props.hasOwnProperty('open') ? this.props.open : this.props.defaultOpen;
        this.state = { open: !!defaultOpen };
        this.uuid = getSafeRandom();
        this.ncc_automated_switch = getGlobalStorage('localStorage', '_ncc_automated_');
    }

    componentDidMount() {
        /*
        * 如果业务组传入supportSearch -> 则支持输入
        * */
        let { supportSearch = false } = this.props;
        // let inputEl = this.selectInput &&
        //     this.selectInput.querySelector(`input`);

        // inputEl &&
        //     supportSearch === false &&
        //     inputEl.setAttribute('readonly', 'readonly');
        // inputEl = null;

        // this.selectInput.addEventListener('click', this.handleInputClick);
    }

    componentWillUnmount() {
        // 移除document事件
        // this.selectInput.removeEventListener('click', this.handleInputClick);
        // this.selectInput = null;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // let oldOpen = this.props.hasOwnProperty('open') ? this.props.open : this.props.defaultOpen;
        // let nextOpen = nextProps.hasOwnProperty('open') ? nextProps.open : nextProps.defaultOpen;
        let oldOpen = this.props.open;
        let nextOpen = nextProps.open;
        if (typeof nextOpen === 'boolean' && oldOpen !== nextOpen) {
            this.setState({ open: nextOpen });
        }
        if (nextProps.isEditable === false && this.state.open) {
            this.setState({ open: false });
        }
    }

    // keyDown
    // keyDownHandler = e => {
    //     // 只有一個  e對象  不過應該夠用了
    //     // enter 键
    //     if (isKeyboard('enter', e)) {
    //         this.props.onEnter && this.props.onEnter({ e });
    //     }

    //     if (isKeyboard('backspace', e) && hasBackSpaceClear(this.props)) {
    //         this.handleClear();
    //     }
    //     this.actionWithHotKey(e);
    // };

    close = e => {
        const { onBlur, value } = this.props;

        if (this.open && this.select && !this.select.contains(e.target)) {
            let timer = setTimeout(() => {
                typeof onBlur === 'function' && onBlur(value);
                this.open = false;
                clearTimeout(timer);
            }, 0);
        }
    };

    handleClear = e => {
        console.log('handleClear');
        //点击下拉框时触发table的rowClick事件 CLOUD-151231
        e && e.stopPropagation();

        let { onFocus, value, disabled } = this.props;

        if (disabled) {
            return;
        }

        if (typeof onFocus === 'function') {
            let result = onFocus(value);

            if (result instanceof Promise) {
                result.then(isContinue => {
                    if (isContinue !== false) {
                        this.clear();
                    }
                });
            } else if (result !== false) {
                this.clear();
            }

        } else {
            this.clear();
        }

    };

    clear = () => {
        console.log('clear');
        let { onChange, onSelect, onBlur, multiple, showSearch, supportSearch } = this.props;
        let emptyValue = (showSearch || supportSearch) ? '' : undefined;
        typeof onChange === "function" && onChange(emptyValue);
        typeof onSelect === "function" && onSelect(emptyValue);
        typeof onBlur === "function" && onBlur(multiple ? [] : emptyValue);

        //把标识设为默认值
        this.clickIcon = false;
    };

    onFocus = val => {
        const { onFocus, isTable, renderInTable } = this.props;
        this.open = true;
        let dom = null;
        this.keyDownTriggerOpen = true;  
        if (isTable) {
            dom = {};
        } else {
            if (
                this.select &&
                this.select.getElementsByClassName &&
                Array.isArray(this.select.getElementsByClassName('base-select'))
            ) {
                dom = this.select.getElementsByClassName('base-select')[0];
            }
        }
        typeof onFocus === 'function' && onFocus(val, dom);
    };

    onChange = (val, option) => {
        const { onChange, value, onOpenChange, multiple } = this.props;
        this.open = true;
        typeof onChange === 'function' && onChange(val, value, option);
        // setTimeout  表格侧拉模式控制 下拉框的  展开收起  by bbqin
        !multiple && onOpenChange && onOpenChange(false);
    };

    onBlur = val => {
        this.open = false;
        this.keyDownTriggerOpen = true;
        const { onBlur } = this.props; // zhanghengh加 ， 否则有bug
        typeof onBlur === 'function' &&
            this.clickIcon !== true &&
            onBlur(val ? [] : undefined);
    };

    /**
     * @param e {obj} 事件源
     */
    handleContainerMouseDown = e => {
        //点击下拉框时触发table的rowClick事件 CLOUD-151231
        e.stopPropagation();
        /*
        * @desc: 点击清空按钮会触发onblur事件，在表格中触发onBlur会切换浏览状态，
        * @resolve：在鼠标点击时判断一下点击的元素是不是清空按钮
        * */
        if (e.target.className.includes('select-icon')) {
            this.clickIcon = true;
        } else {
            this.clickIcon = false;
        }
    };

    handleInputKeyDown = e => {
        let { renderInTable, onInputKeyDown, onEnter, multiple = false, tags = false } = this.props;
        // enter 键避免直接打开了 下拉
        if (!this.state.open && isEnterKeyDown(e, [KeyCode.enter]) && onEnter) {
            // e.stopPropagation();
            this.setState({ open: false });
        }
        // 在table内部，打开，按下上下键， enter不能禁用 ，不然可能触发不了单元格的enter事件
        if (renderInTable && this.state.open && (isArrowKeyDown(e, [KeyCode.down, KeyCode.up]))) { // , KeyCode.enter
            e.stopPropagation();
        }

        // 表格 多选弹开时  不触发enter
        if (renderInTable && this.state.open && isEnterKeyDown(e, [KeyCode.enter]) && multiple) { // , KeyCode.enter
            e.stopPropagation();
        }

        // 表单 多选弹开时  不触发enter
        if (!renderInTable && this.state.open && isEnterKeyDown(e, [KeyCode.enter]) && multiple) { // , KeyCode.enter
            e.stopPropagation();
        }
        // NCC-176928 单选模式下 backspace 清空
        // 去掉backspace逻辑，走浏览器默认行为
        // if (!multiple && !tags && isKeyboard('backspace', e) && hasBackSpaceClear(this.props)) {
        //     this.handleClear();
        // }

        this.actionWithHotKey(e);

        onInputKeyDown && onInputKeyDown(e);
    };

    // handleInputClick = e => {
    //     let { renderInTable } = this.props;
    //     if (renderInTable) {
    //         this.setState({ open: !this.state.open });
    //     }
    // };

    handleSelect = (value, ref) => {
        let { onSelect, renderInTable, multiple } = this.props;
        typeof onSelect === 'function' && onSelect(value, ref);

        if (renderInTable && multiple !== true) {
            this.setState({ open: false });
        }
    };

    actionWithHotKey = e => {
        let { open } = this.state;
        let { renderInTable, hotKeyWithArrow, onOpenChange } = this.props;
        // debugger;
        //control键 打开下拉面版
        if (isKeyboard('ctrl', e) && renderInTable) {
            // this.setState({ open: !open });
            this.keyDownTrigger = true;
        }
        // 不是表格时下拉也可以展开
        if (!renderInTable && (isArrowKeyDown(e, [KeyCode.down]) || isKeyboard('ctrl', e))) {
            if (isArrowKeyDown(e, [KeyCode.down])) {
                // e.preventDefault();
            }
            this.keyDownTrigger = true;
        }

        //表格中按esc 直接关闭
        if (isKeyboard('esc', e) && renderInTable) {
            this.setState({ open: false });
        }

        if (isArrowKeyDown(e, [KeyCode.left, KeyCode.right])) {
            hotKeyWithArrow && hotKeyWithArrow({ e });
        }

        if (renderInTable && !open && isArrowKeyDown(e)) {
            hotKeyWithArrow && hotKeyWithArrow({ e });
        }

        //按下esc
        if (!renderInTable && isKeyboard('esc', e)) {
            onOpenChange && onOpenChange(false);
        }
    };

    render() {
        let {
            className = '', wrapperClassName = '',
            showStar, onBlur, onFocus, onChange, fieldid,
            popData, enterKeyDown = false, multiple,
            supportSearch,
            showSearch,
            getPopupContainer,
            renderInTable, 
            options, 
            onSelect, 
            maxTagCount = 1, 
            dropdownClassName = '', 
            style, 
            virtual,
            ...others
        } = this.props;
        
        // 自动化测试 关闭下拉选项的虚拟滚动
        if (this.ncc_automated_switch === '1') {
            virtual = false;
        }

        showSearch = showSearch || supportSearch;

        if(multiple && this.props.value && !Array.isArray(this.props.value) && this.props.value.label === undefined){
            others.value = [];
        }
        if(multiple){
            maxTagCount = 'auto';
        }else{
            maxTagCount = 1;
        }

        if (getSysFieldid(fieldid)) {
            popData ? popData.fieldid = `${fieldid}_select` : popData = { fieldid: `${fieldid}_select` };
        }
        // if (Array.isArray(options)) {
        //     options = options.map(p => {
        //         return {
        //             label: p.label || p.display,
        //             value: p.value
        //         }
        //     })
        //     others.options = options;
        // }
        let multiClassName = multiple ? 'base-select-multi' : '';
        let cursorClassName = showSearch ? 'base-select-search-pointer' : 'base-select-pointer';
        let ieHackClass = isIE() ? 'ie-hack' : '';

        onSelect = renderInTable ? this.handleSelect : onSelect;

        // 解决options label问题
        // if (options) {
        //     options = options?.map(item => {
        //         let { display, label } = item;
        //         return { ...item, label: label || display };
        //     });
        // }

        // 兼容
        wrapperClassName = className;

        // 此处临时加 uuid 的目的 是tinper往下拉放fieldid属性,必须保证 dropdownCalssName 全局唯一,否则加不上fieldid影响测试自动化
        let defaultDropdownClassName = `select_dropdown_${this.uuid}`;
        //已经给tinper提问题，修复后去掉uuid

        return (
            <div
                className={`base-form-control-wrapper base-select-wrapper ${wrapperClassName} ${cursorClassName} ${ieHackClass}`}
                ref={dom => {
                    this.select = dom;
                }}
                fieldid={getSysFieldid(fieldid) || null}
                onMouseDown={this.handleContainerMouseDown}
                onClick={e => {
                    e.stopPropagation();
                }}
                onMouseDownCapture={ () => {this.keyDownTriggerOpen = true;}} //YBP-RIA-BUG-5383

                onKeyUp={e => {
                    // 表格内的ctrl展开
                    if (this.keyDownTrigger && isKeyboard('ctrl', e) && renderInTable && !isComboKeyboard(e)) {
                        this.setState({ open: true });
                    }
                    // 普通情况下的下键展开
                    if (this.keyDownTrigger && !renderInTable && (isArrowKeyDown(e, [KeyCode.down]) || isKeyboard('ctrl', e)) && !isComboKeyboard(e)) {
                        this.setState({ open: true });
                    }
                    this.keyDownTrigger = false;
                    this.keyDownTriggerOpen = true;
                }}
                onKeyDown={this.handleInputKeyDown}
                onKeyDownCapture={e => {
                    // 解决单选情况下，点击任意快捷键会导致下拉弹出的问题
                    if (!multiple && !showSearch) {
                        const isEsc = e.keyCode === 27 || e.key === "Escape";
                        // 监听浏览器激活了来解决焦点没有失去的问题
                        // 解决alt+tab | meta+tab 
                        // const isSpecial = (e.altKey && e.key === 'Tab') || (e.metaKey && e.key === 'Tab');
                        // 下键  ctrl  esc  enter 能触发open变化
                        if ( (isArrowKeyDown(e, [KeyCode.down]) || isKeyboard('ctrl', e) || isEsc || isEnterKeyDown(e, [KeyCode.enter])) && !isComboKeyboard(e)) {
                            this.keyDownTriggerOpen = true;
                        } else {
                            this.keyDownTriggerOpen = false;
                        }
                    }

                    // 表格里只能按ctrl打开, 不处理会导致  按下键或者enter 下拉闪烁一下
                    if (!this.state.open && renderInTable && !isComboKeyboard(e) && (isArrowKeyDown(e, [KeyCode.down, KeyCode.up, KeyCode.left, KeyCode.right]) || isEnterKeyDown(e, [KeyCode.enter]))) {
                        this.keyDownTriggerOpen = false;
                    }
                }}
                style={style}
            >
                {showStar ? <span className="select-required-tag">*</span> : ''}

                <OriginSelect
                    onDropdownVisibleChange={open => {
                        if (this.keyDownTriggerOpen !== false) {
                            this.open = open;
                            this.setState({ open });
                        }
                    }}
                    dropdownClassName={`base-select-dropdown ${dropdownClassName} ${defaultDropdownClassName}`}
                    getSelectAttrs={() => popData}
                    showSearch={showSearch}
                    popData={popData}
                    className={`base-select ${className} ${multiClassName} ${renderInTable ? 'base-table-select' : ''}`}
                    onFocus={this.onFocus}
                    onChange={this.onChange.bind(this)}
                    onBlur={this.onBlur.bind(this)}
                    // 如果设置了 autofocus  会导致跳转不出去的情况  需要注意的是 外部可能会传入autofocus  TODO  --bbqin
                    // ref={ele => {
                    //     this.selectInput = ReactDOM.findDOMNode(ele); // 获取到组件对象 -- bbqin
                    // }}
                    // onKeyDown={this.keyDownHandler}
                    // enterKeyDown={enterKeyDown}
                    maxTagCount={maxTagCount}
                    multiple={multiple}
                    // allowClear={others.required !== true && others.showClear === true && !!hasValue(others.value)}
                    // onClear={this.handleClear.bind(this)}
                    maxTagPlaceholder={tags => {
                        return '+' + tags.length;
                    }}
                    notFoundContent={<div>&nbsp;</div>}
                    open={this.state.open}
                    // dropdownMatchSelectWidth={false}
                    // onInputKeyDown={this.handleInputKeyDown}
                    // getPopupContainer={() => document.body} //底层组件这个不能写死，需要的话往下传
                    // options={options}
                    onSelect={onSelect}
                    virtual={virtual}
                    style={style}
                    getPopupContainer={typeof getPopupContainer === "function" ? getPopupContainer : null}
                    {...others}
                >
                    {/* {this.props.children} */}
                    {Array.isArray(options)
                        ? options.map(({ display, value }) => {
                            return <Option key={value} value={value}>{display}</Option>;
                        })
                        : this.props.children}

                </OriginSelect>
                {/* 使用tinper的情况icon */}
                {
                    (others.required !== true || multiple ) &&
                    others.showClear === true &&
                    !!hasValue(others.value) &&
                    (
                        <i
                            className={"iconfont icon-qingkong select-icon" + (others.disabled ? ' icon-hidden' : '')}
                            onClick={this.handleClear}
                        // style={{ right: '20px' }}
                        />
                    )
                }
            </div>
        );
    }
}

Select.defaultProps = { showClear: true };

Select.Option = Option;

Select.OptGroup = OptGroup;

export default Select;
